'use strict'
const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

const anios = ['2010', '2011', '2012', '2013', '2014', '2015', '2016', '2017', '2018', '2019', '2020']

const i18n = {
  autoClose: true,
  months: meses,
  monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
  weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
  weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
  cancel: 'Cancelar',
  done: 'Seleccionar',
  setDefaultDate: true
}

const empresas = {
  tonoDigital: 'tonodigital',
  gmCel: 'gmcel'
}





const controles = {
  macrosstech: [
    {
      user: 'BASE UNEFON',
      rutas: ['recargas', 'portabilidades']
    },
    {
      user: 'BASE ATT',
      rutas: ['recargas', 'portabilidades']
    },
    {
      user: 'BASE MOVISTAR',
      rutas: ['recargas', 'portabilidades']
    },
    {
      user: 'ANA DANIELA CUEVAS CANTOR',
      rutas: ['administrarBase',]
    },
    {
      user: 'JACQUELINE QUINTANAR GONZALEZ',
      rutas: ['administrarBase',]
    },
    {
      user: 'JOVANA ELIZABETH GUZMAN LUNA',
      rutas: ['administrarBase',]
    },
    {
      user: 'LUIS ALBERTO HERNANDEZ LUCIANO',
      rutas: ['administrarBase',]
    },
    {
      user: 'JANERY ALEXANDER SANCHEZ IRIARTE',
      rutas: ['administrarBase',]
    },
    {
      user: 'EDUARDO ANTONIO HERNANDEZ MENDOZA',
      rutas: ['administrarBase',]
    }
  ],

  demo: [
    {
      user: 'pruebaAdmin',
      rutas: ['recargas', 'portabilidades']
    },
    {
      user: 'demo13',
      rutas: ['recargasAgendadas', 'portabilidades', 'subirArchivos'],
      permisosArchivos: ['Registrar nuevos', 'Reemplazar', 'Eliminar', 'Recargas Agendadas'],
    },
    {
      user: 'demo2',
      rutas: ['usuarios', 'administrarBase', 'ventas' , 'subirArchivos', 'recargas', 'recargasCarier' ],
      permisosArchivos: ['Registrar nuevos', 'Reemplazar', 'Eliminar'],
      permisosRecargas: ['Reciclar', 'movimientos']
    },
    {
      user: 'demo3',
      rutas: ['usuarios', 'administrarBase', 'ventas' , 'subirArchivos' ],
      permisosArchivos: ['Registrar nuevos', 'Reemplazar', 'Eliminar']
    },
    {
      user: 'ejemplo',
      rutas: ['ventas'],

    }
  ],
  cmtex: [
    {
      user: 'OWENMS1034',
      rutas: ['usuarios', 'recargasMasivas', 'subirArchivos', 'administrarBase', 'ventas', 'administrarRegistos', 'verificacionMasiva' ],
      permisosArchivos: ['Recargas Masivas']
    },{
      user: 'PEDROMS2786',
      rutas: ['usuarios', 'recargasMasivas', 'subirArchivos', 'administrarBase', 'ventas', 'administrarRegistos', 'verificacionMasiva' ],
      permisosArchivos: ['Recargas Masivas']
    },{
      user: 'demo',
      rutas: ['usuarios', 'recargasMasivas', 'subirArchivos', 'administrarBase', 'ventas', 'administrarRegistos', 'verificacionMasiva' ],
      permisosArchivos: ['Recargas Masivas']
    },{
      user: 'LUPAGNL1105',
      rutas: ['usuarios', 'recargasMasivas', 'subirArchivos', 'administrarBase', 'ventas' ],
      permisosArchivos: ['Recargas Masivas']
    },{
      user: 'ALOVAZQ6789',
      rutas: ['administrarBase', 'ventas' , 'subirArchivos', 'recargas' ],
      permisosArchivos: ['Registrar nuevos', 'Reemplazar', 'Eliminar'],
      permisosRecargas: ['Reciclar', 'movimientos']
    },{
      user: 'YATZALM5436',
      rutas: ['administrarBase', 'subirArchivos', 'ventas' ],
      permisosArchivos: ['Registrar nuevos', 'Reemplazar', 'Eliminar']
    }
  ],

  gsmoviles: [{
    user: 'AdminEli',
    rutas: ['recargas', 'portabilidades']
  }],
  teletrial: [{
    user: 'LUPITA',
    rutas: ['recargas']
  }],
  todosim: [
    {
    user: 'ArturoGonzalez',
    rutas: ['subirArchivos', 'administrarBase', 'recargas','usuarios']
  },
    {
      user: 'CESAR',
      rutas: ['subirArchivos', 'administrarBase', 'recargas','usuarios']
    },
    {
    user: 'ADRIANA',
    rutas: ['recargas', 'portabilidades']
  },{
    user: 'COMODIN2',
    rutas: ['recargas', 'portabilidades']
  },{
    user: 'COMOSIN1',
    rutas: ['recargas', 'portabilidades']
  },{
    user: 'FERNANDA',
    rutas: ['recargas', 'portabilidades']
  },{
    user: 'PAOLA',
    rutas: ['recargas', 'portabilidades']
  }],
  discovery:[
    {
      user: 'SegundoNivel',
      rutas: ['recargas', 'portabilidades','subirArchivos', 'administrarBase','ventas','recicladoMasivo', 'usuarios', 'administrarRegistos'],
    },{
      user: 'ALEJANDRA AGUILAR',
      rutas: ['recargas', 'portabilidades','subirArchivos', 'administrarBase','ventas','recicladoMasivo','recargasCarier'],
    },{
      user: 'ANGELICA ROJAS ARZATE',
      rutas: ['recargas', 'portabilidades','subirArchivos', 'administrarBase','ventas','recicladoMasivo'],
    },{
      user: 'BRENDA ORTIZ OCAMPO',
      rutas: ['recargas', 'portabilidades','subirArchivos', 'administrarBase','ventas','recicladoMasivo'],
    },
    {
      user: 'Fernando Rodriguez',
      rutas: ['recargas', 'portabilidades','subirArchivos', 'administrarBase','ventas','recicladoMasivo'],
    },
    {
      user: 'TercerNivel',
      rutas: ['recargas', 'portabilidades','subirArchivos', 'administrarBase','ventas','recicladoMasivo'],
    }
  ],
  comint:[
    {
      user: 'usuarioRecargas',
      rutas: ['recargas'],
    }
  ],
  nucel:[
    {
      user: 'Daniel Solorio',
      rutas: ['ventas'],
    },{
      user: 'Judith24',
      rutas: ['ventas'],
    },{
      user: 'Ross24 ',
      rutas: ['ventas'],
    }
  ]

}

const permisos = {
  RECARGAS_MASIVAS: 'RECARGAS_MASIVAS',
  RETROALIMENTACION_LIDER: 'RETROALIMENTACION_LIDER',
  MONTO_LIDER: 'MONTO_LIDER',
  MOVI_DN: 'MOVI_SIN_DN',
  ATT_DN: 'ATT_SIN_DN',
  GRAFICAS: 'GRAFICAS',
  PORTABILIDADES: 'PORTABILIDADES',
  USUARIO_CLIENTE: 'USUARIO_CLIENTE',
  INVENTARIO: 'INVENTARIO',
  RECARGA_EXTERNA: 'RECARGA_EXTERNA',
  RECARGAS_CARRIER: 'RECARGAS_CARRIER',
  RECARGAS_PLATAFORMA: 'RECARGAS_PLATAFORMA',
  PERMISO_MONTOS: 'PERMISO_MONTOS',
  RECICLADO_MASIVO: 'RECICLADO_MASIVO',
  RECARGAS_AGENDADAS: 'RECARGAS_AGENDADAS'
}




const passwordRequirements=[
  {
    name: `characters`,
    label: `4 Caracteres`,
    regex: new RegExp("^.{4,}$"),
    isVisible: true,
    requested: true,
  },
  {
    name: `lowercase`,
    label: `1 Minuscula`,
    regex: new RegExp("[a-z]"),
    isVisible: true,
    requested: true,
  },
  {
    name: `uppercase`,
    label: `1 Mayuscula`,
    regex: new RegExp("[A-Z]"),
    isVisible: true,
    requested: true,
  },
  // {
  //   name: `numbers`,
  //   label: `1 Número`,
  //   regex: new RegExp("[0-9]"),
  //   isVisible: true,
  //   requested: true,
  // },
  // {
  //   name: `symbols`,
  //   label: `1 Simbolo`,
  //   regex: new RegExp("[^A-Za-z0-9\\s]"),
  //   isVisible: true,
  //   requested: true,
  // },
  {
    name: `withoutSpaces`,
    label: `Caracteres no validos`,
    regex: new RegExp("\\s"),
    isVisible: false,
    requested: true,
  }
]

const passwordRequirementsAdmin=[
  {
    name: `characters`,
    label: `10 Caracteres`,
    regex: new RegExp("^.{10,}$"),
    isVisible: true,
    requested: true,
  },
  {
    name: `lowercase`,
    label: `1 Minuscula`,
    regex: new RegExp("[a-z]"),
    isVisible: true,
    requested: true,
  },
  {
    name: `uppercase`,
    label: `1 Mayuscula`,
    regex: new RegExp("[A-Z]"),
    isVisible: true,
    requested: true,
  },
  {
    name: `numbers`,
    label: `2 Números`,
    regex: new RegExp("(?:\\D*\\d){2}"),
    isVisible: true,
    requested: true,
  },
  {
    name: `symbols`,
    label: `1 Simbolo`,
    regex: new RegExp("[^A-Za-z0-9\\s]"),
    isVisible: true,
    requested: true,
  },
  {
    name: `withoutSpaces`,
    label: `Caracteres no validos`,
    regex: new RegExp("\\s"),
    isVisible: false,
    requested: true,
  }
]

module.exports = {
  i18n,
  meses,
  anios,
  empresas,
  permisos,
  controles,
  passwordRequirements,
  passwordRequirementsAdmin
}
